
/*急ごしらえのため改修まではコピペ不可*/
window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.innerHTML="";
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  sizemsg_dowel.style.visibility="hidden";
  opmsg.style.visibility="hidden";
  document.getElementById("width").value="";
  document.getElementById("depth").value="";
  document.getElementById("height").value="";
  document.getElementById("price").value="";
  document.getElementById("material").innerHTML = "選択してください";
  //document.getElementById("material_sub").innerHTML = "選択してください";
  let cancel = document.getElementsByName('color_main');
  let cancel3 = document.getElementsByName('color_front');
  let cancel2 = document.querySelectorAll(`input[type='checkbox']`);
  document.getElementById("op_haisenB").value="";
  document.getElementById("op_haisenL").value="";
  document.getElementById("op_panel").value="";
  document.getElementById("op_haisenB").disabled = true;
  document.getElementById("op_haisenL").disabled = true;
  document.getElementById("op_panel").disabled = true;
  for (const i of cancel) {i.checked = false;}
  for (const i of cancel2) {i.checked = false;}
  for (const i of cancel3) {i.checked = false;}
  var select = document.getElementById("columns");select.options[0].selected = true;
  var select = document.getElementById("rows");select.options[0].selected = true;
  $("#box_img div:nth-of-type(1) img:nth-of-type(4)").css("visibility","visible");
  $("#box_img div:nth-of-type(2) img:nth-of-type(4)").css("visibility","visible");
  $("#size_img .arrow img:nth-of-type(4)").css("visibility","visible");
  let colorList = document.getElementsByName("color_front");
  for (var i=0;i<colorList.length;i++){
    var activate="#"+colorList[i].id;
    $(activate).prop("disabled", true);
  }
  resizing();
}
window.onresize = function(){resizing();
}
//格納divリサイズ
function resizing(){
  var size_acquisition = document.getElementById("size_acquisition");
  var hsize = size_acquisition.clientHeight-1;
  var wsize = Math.floor(hsize/85);
  $("#size_img .arrow").css("height",hsize+"px");
  $("#box_img div:nth-of-type(1)").css("height",hsize+"px");
  $("#box_img div:nth-of-type(2)").css("height",hsize+"px");
  $("#box_img div:nth-of-type(2)").css("margin-top","-"+hsize+"px");
  $("#box_img div:nth-of-type(3)").css("margin-top","-"+hsize+"px");
  $("#box_img div:nth-of-type(3) img").css("width",wsize+"px");
  $("#box_img div:nth-of-type(4)").css("margin-top","-"+hsize+"px");
  $("#box_img div:nth-of-type(4) img").css("width",wsize+"px");
  changeSize();
}

//カート中身リセット
function cartReset(){
    document.getElementById("price").value="";
    cart_price.innerHTML =""+" 円";
    cart_width.innerHTML="";
    cart_depth.innerHTML="";
    cart_height.innerHTML="";
    cart_columns.innerHTML="";
    cart_rows.innerHTML="";
    cart_main_color.innerHTML="";
    cart_border_color.innerHTML="";
    cart_option.innerHTML="";
    cart_haisen.innerHTML="";
    cart_panel.innerHTML="";
    cart_opprice.innerHTML="";
    linkmsg.style.visibility="hidden";
}

//画像変更
function colorMain(changeImg){
  var colorList = document.getElementsByName("color_main");
  for (var i=0;i<colorList.length;i++){
    if(colorList[i].checked){
      if(i<=13){var chooseColor=colorList[i].id.slice(5);
        for (var j=0;j<=13;j++){
                activate="#"+colorList[j].id+"2";
                $(activate).prop("disabled", false);
        }$(".front_tab").css({"backgroundColor":"#fafafa","opacity":"1"});
      }
      else{var chooseColor=colorList[i].id;
          for (var j=0;j<=13;j++){
          activate="#"+colorList[j].id+"2";
          $(activate).prop("disabled", true);
          }
          for (const element of document.getElementsByName("color_front")) {element.checked = false;}
          $(".front_tab").css({"backgroundColor":"#ccc","opacity":"0.4"});
          }
    }
  }
  //$("#wood_bkw2").prop("disabled", true); 欠品時
  let imgSrc1 = $(document.area1).attr("src").split("/");
  let imgSrc2 = $(document.area2).attr("src").split("/");
  imgSrc1 = $(document.area1).attr("src").replace(imgSrc1[9] , chooseColor);
  imgSrc2 = $(document.area2).attr("src").replace(imgSrc2[9] , chooseColor);
  $(document.area1).attr('src', imgSrc1);
  $(document.area2).attr('src', imgSrc2);
  
  var colorList = document.getElementsByName("color_front");
  for (var i=0;i<colorList.length;i++){
    if(colorList[i].checked){
      var chooseColor=colorList[i].id.slice(5,-1);
    }
    var imgSrc3 = $(document.area3).attr("src").split("/");
    var imgSrc4 = $("#box_img div:nth-of-type(3)").find("img");
    if (imgSrc4.length){
      var imgSrc4 = $(document.area4).attr("src").split("/");
      var imgSrc4 = $(document.area4).attr("src").replace(imgSrc4[9] , chooseColor);
    }else{;}
    var imgSrc5 = $("#box_img div:nth-of-type(4)").find("img");
    if (imgSrc5.length){
      var imgSrc5 = $(document.area5).attr("src").split("/");
      var imgSrc5 = $(document.area5).attr("src").replace(imgSrc5[9] , chooseColor);
    }else{;}
    var imgSrc6 = $(document.area6).attr("src").split("/");
    var imgSrc3 = $(document.area3).attr("src").replace(imgSrc3[9] , chooseColor);
    var imgSrc6 = $(document.area6).attr("src").replace(imgSrc6[9] , chooseColor);
    $(document.area3).attr('src', imgSrc3);
    $(document.area4).attr('src', imgSrc4);
    $(document.area5).attr('src', imgSrc5);
    $(document.area6).attr('src', imgSrc6);
  }
}
function colorSub(changeImg){
  let colorList = document.getElementsByName("color_front");
  for (var i=0;i<colorList.length;i++){
    if(colorList[i].checked){
      var chooseColor=colorList[i].id.slice(5,-1);
    }
  }
  var imgSrc3 = $(document.area3).attr("src").split("/");
  var imgSrc3 = $(document.area3).attr("src").replace(imgSrc3[9] , chooseColor);
  var imgSrc4 = $("#box_img div:nth-of-type(3)").find("img");
  if (imgSrc4.length){
    var imgSrc4 = $(document.area4).attr("src").split("/");
    var imgSrc4 = $(document.area4).attr("src").replace(imgSrc4[9] , chooseColor);
  }else{;}
  var imgSrc5 = $("#box_img div:nth-of-type(4)").find("img");
  if (imgSrc5.length){
    var imgSrc5 = $(document.area4).attr("src").split("/");
    var imgSrc5 = $(document.area4).attr("src").replace(imgSrc5[9] , chooseColor);
  }else{;}
  var imgSrc6 = $(document.area6).attr("src").split("/");
  var imgSrc6 = $(document.area6).attr("src").replace(imgSrc6[9] , chooseColor);
  $(document.area3).attr('src', imgSrc3);
  $(document.area4).attr('src', imgSrc4);
  $(document.area5).attr('src', imgSrc5);
  $(document.area6).attr('src', imgSrc6);
}
function changeSize() {
  var changeSize1 = $(document.area1).attr("src").split("/");
  var changeSize2 = $(document.area2).attr("src").split("/");
  var changeSize3 = $(document.area3).attr("src").split("/");
  if (typeof(changeSize4) !== "undefined"){var changeSize4 = $(document.area4).attr("src").split("/");}
  if (typeof(changeSize5) !== "undefined"){var changeSize5 = $(document.area5).attr("src").split("/");}
  var changeSize6 = $(document.area6).attr("src").split("/");
  changeImgW = Number(document.getElementById("width").value);
  changeImgH = Number(document.getElementById("height").value);
  if(changeImgW == 0){changeImgW = 180;}
  if(changeImgH == 0){changeImgH = 180;}
  switch (changeImgW != null) {
    case changeImgW <= 30:changeWidth = "1";break;
    case changeImgW <= 50:changeWidth = "2";break;
    case changeImgW <= 80:changeWidth = "3";break;
    case changeImgW <= 100:changeWidth = "4";break;
    case changeImgW <= 120:changeWidth = "5";break;
    case changeImgW <= 150:changeWidth = "6";break;
    default:changeWidth = "7";
  }
  switch (changeImgH != null) {
    case changeImgH <= 50:changeHeight = "2";break;
    case changeImgH <= 80:changeHeight = "3";break;
    case changeImgH <= 100:changeHeight = "4";break;
    case changeImgH <= 120:changeHeight = "5";break;
    case changeImgH <= 150:changeHeight = "6";break;
    default:changeHeight = "7";
  }
  //画像表示サイズ変更
  var sizeChange1 = $(document.area1).attr("src").replace(changeSize1[10] , changeWidth+changeHeight);
  var sizeChange2 = $(document.area2).attr("src").replace(changeSize2[10] , changeWidth);
  var sizeChange3 = $(document.area3).attr("src").replace(changeSize3[10] , changeWidth);
  if (typeof(changeSize4) !== "undefined"){var sizeChange4 = $(document.area4).attr("src").replace(changeSize4[10] , changeHeight);}
  if (typeof(changeSize5) !== "undefined"){var sizeChange4 = $(document.area5).attr("src").replace(changeSize5[10] , changeHeight);}
  var sizeChange6 = $(document.area6).attr("src").replace(changeSize6[10] , changeWidth+changeHeight);
  $(document.area1).attr("src", sizeChange1+".png");
  $(document.area2).attr("src", sizeChange2+".png");
  $(document.area3).attr("src", sizeChange3+".png");
  if (typeof(changeSize4) !== "undefined"){$(document.area4).attr("src", sizeChange4+".png");}
  if (typeof(changeSize5) !== "undefined"){$(document.area5).attr("src", sizeChange5+".png");}
  $(document.area6).attr("src", sizeChange6+".png");
  //格納divリサイズ
  var getWsize = document.getElementById("size_acquisition");
  var divWsize = size_acquisition.clientWidth;
  divWsize = Math.floor(divWsize/7);
  wsize = Math.floor(divWsize*changeWidth);
  var selectColumns = document.getElementById("columns").value;
  divWsize = Math.floor(wsize/selectColumns);
  var hsize = size_acquisition.clientHeight;
  rowHsize = Math.floor(hsize/7);
  rowHsize = Math.floor(rowHsize*changeHeight);
  $("#box_img div:nth-of-type(1)").css("width",wsize+"px");
  $("#box_img div:nth-of-type(2)").css("width",wsize+"px");
  $("#box_img div:nth-of-type(3)").css("width",wsize+"px");
  $("#box_img div:nth-of-type(4)").css("width",wsize+"px");
  $("#box_img div:nth-of-type(5)").css("width",wsize+"px");
  $("#size_img .arrow").css("height",(hsize-rowHsize)+rowHsize+"px");
  $("#box_img div:nth-of-type(1)").css("height",rowHsize+"px");
  $("#box_img div:nth-of-type(2)").css("height",rowHsize+"px");
  $("#box_img div:nth-of-type(3)").css("height",rowHsize+"px");
  $("#box_img div:nth-of-type(4)").css("height",rowHsize+"px");
  $("#box_img div:nth-of-type(5)").css("height",rowHsize+"px");
  $("#box_img div:nth-of-type(5) img").css("height",rowHsize+"px");
  $("#size_img .arrow").css("padding-top",hsize-rowHsize+"px");
  $("#box_img div:nth-of-type(1)").css("padding-top",hsize-rowHsize+"px");
  $("#box_img div:nth-of-type(2)").css("margin-top","-"+rowHsize+"px");
  $("#box_img div:nth-of-type(3)").css("margin-top","-"+rowHsize+"px");
  $("#box_img div:nth-of-type(4)").css("margin-top","-"+rowHsize+"px");
  $("#box_img div:nth-of-type(5)").css("margin-top","-"+rowHsize+"px");
}
function changePanel(){
  let colorType1 = $(document.area2).attr("src").split("/");colorType1 = colorType1[9];
  let colorType2 = $(document.area3).attr("src").split("/");colorType2 = colorType2[9];
  var changeColumns =6;
  var changeRows=6;
  $("#size_img .arrow").empty();
  $("#box_img div:nth-of-type(1)").empty();
  $("#box_img div:nth-of-type(2)").empty();
  $("#box_img div:nth-of-type(3)").empty();
  $("#box_img div:nth-of-type(4)").empty();
  $("#box_img div:nth-of-type(5)").empty();
  changeImg = document.getElementById("columns").selectedIndex;
  switch (changeImg) {
    case 0:changeColumns = 6;break;
    case 1:changeColumns = 5;break;
    case 2:changeColumns = 4;break;
    case 3:changeColumns = 3;break;
    case 4:changeColumns = 2;break;
    case 5:changeColumns = 1;break;
    case 6:changeColumns = 0;break;
    default:changeColumns = 6;
  }
  changeImg = document.getElementById("rows").selectedIndex;
  switch (changeImg) {
    case 0:changeRows = 6;break;
    case 1:changeRows = 5;break;
    case 2:changeRows = 4;break;
    case 3:changeRows = 3;break;
    case 4:changeRows = 2;break;
    case 5:changeRows = 1;break;
    default:changeRows = 6;
  }
  let saveRow1="<img src=\"https://www.rakuten.ne.jp/gold/arne-style/size_order/images/h001/rows/"+colorType1+"/7.png\" name=\"area2\">"
  let saveRow2="<img src=\"https://www.rakuten.ne.jp/gold/arne-style/size_order/images/h001/front/"+colorType2+"/7.png\" name=\"area3\">"
  let saveColumn1="<img src=\"https://www.rakuten.ne.jp/gold/arne-style/size_order/images/h001/columns/"+colorType2+"/7.png\" name=\"area4\">"
  let saveColumn2="<img src=\"https://www.rakuten.ne.jp/gold/arne-style/size_order/images/h001/columns/"+colorType2+"/7.png\" name=\"area5\">"
  for(let i=0;i<changeRows;i++){$("#box_img div:nth-of-type(1)").append(saveRow1);}
  for(let i=0;i<changeRows;i++){$("#box_img div:nth-of-type(2)").append(saveRow2);}
  for(let i=0;i<changeColumns;i++){$("#box_img div:nth-of-type(3)").append(saveColumn1);}
  for(let i=0;i<changeColumns;i++){$("#box_img div:nth-of-type(4)").append(saveColumn2);}
  
  let arrow="<img src=\"https://www.rakuten.ne.jp/gold/arne-style/size_order/images/h001/arrow.png\">"
  for(let i=0;i<changeRows;i++){$("#size_img .arrow").append(arrow);}
  
  resizing();
}

//材質切替
function materialWood(){document.getElementById("material").innerHTML = "リーズナブル木目：<br class=\"delete\">[材質]プリント化粧合板";}
function materialAino(){document.getElementById("material").innerHTML = "パステルカラーaino：<br class=\"delete\">[材質]プリント化粧合板";}
function materialMela(){document.getElementById("material").innerHTML = "ハイグレード鏡面仕上げ：<br>[本体]メラミン樹脂化粧合板 <br class=\"delete\">[背板]プリント化粧合板";}
//function materialWoodsub(){document.getElementById("material_sub").innerHTML = "リーズナブル木目：<br class=\"delete\">[材質]プリント化粧合板";}
//function materialAinosub(){document.getElementById("material_sub").innerHTML = "パステルカラーaino：<br class=\"delete\">[材質]プリント化粧合板";}

//オプション追加
function op_paneltext( textid, ischecked ) {
   if(ischecked == true ){
    document.getElementById(textid).disabled = false;
      $("#op_panel").css({
        opacity:"1",
        backgroundColor:"#fff",
        border:"#ccc 1px solid"
      });
   }
   else {
     document.getElementById(textid).disabled = true;
      $("#op_panel").css({
        opacity:"0.3",
        backgroundColor:"#f7f7f7",
        border:"#ccc 1px solid"
      });
      document.getElementById("op_panel").value="";
      cartReset();
   }
}
function op_panelchange(){cartReset();}
function op_haisentext( textid, ischecked ) {
   textidL = textid+"L";
   textidB = textid+"B";
   if(ischecked == true ){
    document.getElementById(textidL).disabled = false;
    document.getElementById(textidB).disabled = false;
      $("#op_haisenL,#op_haisenB").css({
        opacity:"1",
        backgroundColor:"#fff",
        border:"#ccc 1px solid"
      });
   }
   else {
     document.getElementById(textidL).disabled = true;
     document.getElementById(textidB).disabled = true;
      $("#op_haisenL,#op_haisenB").css({
        opacity:"0.3",
        backgroundColor:"#f7f7f7",
        border:"#ccc 1px solid"
      });
      document.getElementById("op_haisenL").value="";
      document.getElementById("op_haisenB").value="";
      cartReset();
   }
}
function op_haisenchange(){cartReset();}

//リアルタイムサイズチェック
function changeMsg(){
    var intWidth=Number(document.getElementById("width").value);
    var intDepth=Number(document.getElementById("depth").value);
    var intHeight=Number(document.getElementById("height").value);
    sizemsg.style.visibility="hidden";
    sizemsg_dowel.style.visibility="hidden";
    var intTwo_side=intWidth+intHeight;
    var intColumns=Number(document.getElementById("columns").value);
    var intRows=Number(document.getElementById("rows").value);
    var storageW = Math.floor((intWidth-((intColumns-1)*2+4))/intColumns);
    
    if(intHeight == 0||intHeight > 80){
      if(intRows == 7){
      $("#size_img .arrow img:nth-of-type(4)").css("visibility","visible");
      $("#size_img .arrow img:nth-of-type(4)").css("visibility","visible");}
      else if(intRows == 6||intRows == 5){
      $("#size_img .arrow img:nth-of-type(3)").css("visibility","visible");
      $("#size_img .arrow img:nth-of-type(3)").css("visibility","visible");}
      else if(intRows == 4||intRows == 3){
      $("#size_img .arrow img:nth-of-type(2)").css("visibility","visible");
      $("#size_img .arrow img:nth-of-type(2)").css("visibility","visible");}
      else if(intRows == 2){
      $("#size_img .arrow img").css("visibility","visible");
      $("#size_img .arrow img").css("visibility","visible");}
    }
    if(intHeight !== 0 && intHeight <= 80){
      if(intRows == 7){
      $("#size_img .arrow img:nth-of-type(4)").css("visibility","hidden");
      $("#size_img .arrow img:nth-of-type(4)").css("visibility","hidden");}
      else if(intRows == 6||intRows == 5){
      $("#size_img .arrow img:nth-of-type(3)").css("visibility","hidden");
      $("#size_img .arrow img:nth-of-type(3)").css("visibility","hidden");}
      else if(intRows == 4||intRows == 3){
      $("#size_img .arrow img:nth-of-type(2)").css("visibility","hidden");
      $("#size_img .arrow img:nth-of-type(2)").css("visibility","hidden");}
      else if(intRows == 2){
      $("#size_img .arrow img").css("visibility","hidden");
      $("#size_img .arrow img").css("visibility","hidden");}
    }
    
    cartReset();
    if (intDepth==""||intWidth==""||intHeight==""){
    document.getElementById("storage").innerHTML = "　";
    document.getElementById("panel").innerHTML = "　";
    document.getElementById("sizemsg").innerHTML = "<p> </p>";
    document.getElementById("sizemsg_dowel").innerHTML = "<p> </p>";
    sizemsg.style.visibility="hidden";
    sizemsg_dowel.style.visibility="hidden";
        return false;
    }
    if (intWidth < 15 || intWidth > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅15cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 15 || intDepth > 60){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行15cm未満・奥行61cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 30 || intHeight > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ30cm未満・高さ181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intTwo_side > 270){document.getElementById("sizemsg").innerHTML = "<p>※ 幅と高さの合計が271cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intWidth > 100 && intHeight > 100){document.getElementById("sizemsg").innerHTML = "<p>※ 幅101cm以上の場合、高さ101cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intWidth > 60 && intColumns == "1" || intWidth > 120 && intColumns == "2"){document.getElementById("sizemsg").innerHTML = "<p>※ ご希望の幅の場合、"+intColumns+"列はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("storage").innerHTML= "約"+storageW;
    if (storageW < 7){document.getElementById("sizemsg").innerHTML = "<p>※ 収納幅が7cm未満の場合はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>";
    
    var intPanel = null;
    if(intHeight > 80){intPanel = (intRows-2)*intColumns;}
    else intPanel = (intRows-1)*intColumns;
    document.getElementById("panel").innerHTML= intPanel;
    
    if (intPanel == 0){document.getElementById("sizemsg_dowel").innerHTML = "<p>※ ご希望のサイズの場合、ダボ穴はございません。必要な場合は備考欄に【ダボ穴希望】とご記載ください。 ※</p>";sizemsg_dowel.style.visibility="visible";return false;}
    if (intHeight > 80 && intRows == 3){document.getElementById("sizemsg_dowel").innerHTML = "<p>※ ご希望のサイズの場合、<font color=\"#D12225\">固定棚より下にダボ穴はございません</font>。必要な場合は備考欄に【ダボ穴希望】とご記載ください。 ※</p>";sizemsg_dowel.style.visibility="visible";return false;}

 sizemsg.style.visibility="hidden";
 sizemsg_dowel.style.visibility="hidden";
}

//サイズオーダー
const strLink1="<a href=\"https://item.rakuten.co.jp/arne-style/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,width,depth,height,color,price){
this.url=url;this.width=width;this.depth=depth;this.height=height;this.color=color;this.price=price;}

function searchURL(strWidth,strDepth,strHeight,strColor){
var strErr;
var intColumns=Number(document.getElementById("columns").value);
var storageW = Math.floor((strWidth-((intColumns-1)*2+4))/intColumns);
var intTwo_side=strWidth+strHeight;
//サイズチェック
if (strWidth < 15 || strWidth > 180){strErr="幅15cm未満・幅181cm以上は";}
else if (strDepth < 15 || strDepth > 60){strErr="奥行15cm未満・奥行61cm以上は";}
else if (strHeight < 30 || strHeight > 180){strErr="高さ30cm未満・高さ181cm以上は";}
else if (intTwo_side > 270){strErr="幅と高さの合計が271cm以上は";}
else if (strWidth > 100 && strHeight > 100){strErr="幅101cm以上の場合、高さ101cm以上は";}
else if (strWidth > 60 && intColumns == "1" || strWidth > 120 && intColumns == "2"){strErr="ご希望の幅の場合、"+intColumns+"列は";}
else if (storageW < 7){strErr="収納幅が7cm未満の場合は";}

if(strErr){document.getElementById("price").value="";
return strErr+"オーダー不可です。";}

var listColumn;
var listRows;
var listType;

//幅サイズ成形
switch(listColumn == null){
  case strWidth <= 30: listColumn = 1; break;
  case strWidth <= 50: listColumn = 2; break;
  case strWidth <= 80: listColumn = 3; break;
  case strWidth <= 100: listColumn = 4; break;
  case strWidth <= 120: listColumn = 5; break;
  case strWidth <= 150: listColumn = 6; break;
  case strWidth <= 180: listColumn = 7; break;
}

//高さサイズ成形
switch(listRows == null){
  case strHeight <= 50: listRows = 1; break;
  case strHeight <= 80: listRows = 2; break;
  case strHeight <= 100: listRows = 3; break;
  case strHeight <= 120: listRows = 4; break;
  case strHeight <= 150: listRows = 5; break;
  case strHeight <= 180: listRows = 6; break;
}

var sellPrice;
var data = [];
if(strColor == "wood" || strColor == "aino"){
  if(strDepth <= 20){var tr = $("#price_wood .D150_200 tr");priceList();}
  else if(strDepth <= 30){var tr = $("#price_wood .D210_300 tr");priceList();}
  else if(strDepth <= 40){var tr = $("#price_wood .D310_400 tr");priceList();}
  else if(strDepth <= 50){var tr = $("#price_wood .D410_500 tr");priceList();}
  else if(strDepth <= 60){var tr = $("#price_wood .D510_600 tr");priceList();}
}
else if(strColor == "nail" || strColor == "black"){
  if(strDepth <= 20){var tr = $("#price_nail_bk .D150_200 tr");priceList();}
  else if(strDepth <= 30){var tr = $("#price_nail_bk .D210_300 tr");priceList();}
  else if(strDepth <= 40){var tr = $("#price_nail_bk .D310_400 tr");priceList();}
  else if(strDepth <= 50){var tr = $("#price_nail_bk .D410_500 tr");priceList();}
  else if(strDepth <= 60){var tr = $("#price_nail_bk .D510_600 tr");priceList();}
}
else if(strColor == "bp"){
  if(strDepth <= 20){var tr = $("#price_bp .D150_200 tr");priceList();}
  else if(strDepth <= 30){var tr = $("#price_bp .D210_300 tr");priceList();}
  else if(strDepth <= 40){var tr = $("#price_bp .D310_400 tr");priceList();}
  else if(strDepth <= 50){var tr = $("#price_bp .D410_500 tr");priceList();}
  else if(strDepth <= 60){var tr = $("#price_bp .D510_600 tr");priceList();}
}
else if(strColor == "mb" || strColor == "gs" || strColor == "ww"){
  if(strDepth <= 20){var tr = $("#price_mb_gs_ww .D150_200 tr");priceList();}
  else if(strDepth <= 30){var tr = $("#price_mb_gs_ww .D210_300 tr");priceList();}
  else if(strDepth <= 40){var tr = $("#price_mb_gs_ww .D310_400 tr");priceList();}
  else if(strDepth <= 50){var tr = $("#price_mb_gs_ww .D410_500 tr");priceList();}
  else if(strDepth <= 60){var tr = $("#price_mb_gs_ww .D510_600 tr");priceList();}
}
function priceList(){ for( var i=0,l=tr.length;i<l;i++ ){
  var cells = tr.eq(i).children();
  for( var j=0,m=cells.length;j<m;j++ ){
    if( typeof data[i] === "undefined" )
      data[i] = [];
    data[i][j] = cells.eq(j).text();
  }}
  sellPrice = data[listRows][listColumn];
}

return sellPrice;
}

/*リストから商品URLを取得*/
function checkURL(strWidth,strDepth,strHeight,strColor){
switch(true){
 default:
  for(var i in goods){
if(goods[i].width==strWidth && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value="";

var strDepth=Number(document.getElementById("depth").value);
var strWidth=Number(document.getElementById("width").value);
var strHeight=Number(document.getElementById("height").value);
var strColumns=Number(document.getElementById("columns").value);
var strRows=Number(document.getElementById("rows").value);
var idColor_main = document.getElementsByName("color_main") ;
var idColor_front = document.getElementsByName("color_front") ;
var strColor_main = "";
var strColor_front = "";
var i=0;
var c=0;
var n=0;
for ( strColor_main="", i=idColor_main.length; i--; ) {
 if ( idColor_main[i].checked ) {
     if( idColor_main[i].id.slice(0,4)=="wood" ){
         strColor_main = idColor_main[i].id.slice(0,4);
     }else if( idColor_main[i].id.slice(0,4)=="aino" ){
         strColor_main = idColor_main[i].id.slice(0,4);
     }else{
         strColor_main = idColor_main[i].id;
     }
  var valueColor_main = idColor_main[i].value ;
  break ;
 }
}
for ( strColor_front="", n=idColor_front.length; n--; ) {
 if ( idColor_front[n].checked ) {
     if( idColor_front[n].id.slice(0,3)=="leg" ){
         strColor_front = idColor_front[n].id.slice(0,3);
     }else{
         strColor_front = idColor_front[n].id;
     }
  var valueColor_front = idColor_front[n].value ;
  break ;
 }
}

//オプション：追加棚板
var intOPpanel = Number(document.getElementById("op_panel").value);
var intPanel = null;
var data = [];
var defaultPanel = Number(document.getElementById("panel").innerHTML);
intPanel = intOPpanel+defaultPanel;
if(strColor_main=="wood"||strColor_main=="aino"){var tr = $("#price_panel .panel_wood tr");}
else if(strColor_main=="nail"||strColor_main=="black"||strColor_main=="bp"){var tr = $("#price_panel .panel_nailblackbp tr");}
else if(strColor_main=="mb"||strColor_main=="gs"||strColor_main=="ww"){var tr = $("#price_panel .panel_mbgsww tr");}

var listColumn = "";
var listRows = "";
var storageW = Math.floor((changeImgW-((strColumns-1)*2+4))/strColumns);

switch(listColumn == ""){
  case storageW <= 20: listColumn = 1; break;
  case storageW <= 30: listColumn = 2; break;
  case storageW <= 40: listColumn = 3; break;
  case storageW <= 50: listColumn = 4; break;
  case storageW <= 60: listColumn = 5; break;
}
switch(listRows == ""){
  case strDepth <= 20: listRows = 1; break;
  case strDepth <= 30: listRows = 2; break;
  case strDepth <= 40: listRows = 3; break;
  case strDepth <= 50: listRows = 4; break;
  case strDepth <= 60: listRows = 5; break;
}

var strOption = "なし";
if(intOPpanel !== 0){
strOption = "追加棚板";
for( var i=0,l=tr.length;i<l;i++ ){
  var cells = tr.eq(i).children();
  for( var j=0,m=cells.length;j<m;j++ ){
    if( typeof data[i] === "undefined" )
      data[i] = [];
    data[i][j] = cells.eq(j).text();
  }}
  var total = data[listRows][listColumn];
  total = total*intOPpanel;
  }else var total = 0;

const intOPhaisenL = document.getElementById("op_haisenL").value;
const intOPhaisenB = document.getElementById("op_haisenB").value;
if(intOPhaisenL !== "" && intOPhaisenB !== ""){
  var strHaisen = "左から"+intOPhaisenL+"×下から"+intOPhaisenB;
  if(strOption == "なし"){strOption = "配線穴";}
  if(strOption == "追加棚板"){strOption = "配線穴・"+strOption;}
  total = total+3000;
}


if (isNumber(strWidth)==false){alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");return false;}
if (isNumber(strDepth)==false){alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
if (isNumber(strHeight)==false){alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
if (strColor_main==false){alert("本体カラーを選択してください");return false;}
var opPanelCheck= document.getElementById("op_panelarea");
if(opPanelCheck.checked){if(intOPpanel==0 || isNumber(intOPpanel)==false){alert("追加棚板は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}}
var opHaisenCheck= document.getElementById("op_haisenarea");
if(opHaisenCheck.checked){
  if(intOPhaisenL==0 || isNumber(intOPhaisenL)==false){alert("配線穴の位置指定は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
  if(intOPhaisenB==0 || isNumber(intOPhaisenB)==false){alert("配線穴の位置指定は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
}


document.getElementById("choice1").value=strWidth+"cm";
document.getElementById("choice2").value=strDepth+"cm";
document.getElementById("choice3").value=strHeight+"cm";
document.getElementById("choice4").value=strColumns+"列";
document.getElementById("choice5").value=strRows+"段";
document.getElementById("choice6").value=valueColor_main;
if(typeof valueColor_front === "undefined"){
  document.getElementById("choice7").value=valueColor_main;
}else document.getElementById("choice7").value=valueColor_front;
document.getElementById("choice8").value=strOption;
if(typeof strHaisen === "undefined"){
  document.getElementById("choice9").value="なし"
}else document.getElementById("choice9").value="配線穴位置指定：" +strHaisen+"cm"
document.getElementById("choice10").value="棚板枚数：" +intPanel+"枚";
document.getElementById("choice12").value="追加金額：" +total+"/";
//商品ページの有無チェック
var comcode=checkURL(strWidth,strDepth,strHeight,strColor_main,strColumns,strRows);
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
  
var url=searchURL(strWidth,strDepth,strHeight,strColor_main,strColumns,strRows);

if(!url){
alert("幅、奥行を選んでください");
return false;
}

var intUnit;
if (isNaN(url)==false){
  intUnit=(parseInt(url)+total)/500;//500円単位
  document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
  cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
  cart_width.innerHTML=strWidth;
  cart_depth.innerHTML=strDepth;
  cart_height.innerHTML=strHeight;
  cart_columns.innerHTML=strColumns;
  cart_rows.innerHTML=strRows;
  cart_main_color.innerHTML=valueColor_main;
  cart_opprice.innerHTML=total;
  if(typeof valueColor_front === "undefined"){
    cart_border_color.innerHTML=valueColor_main;
  }else cart_border_color.innerHTML=valueColor_front;
  cart_option.innerHTML=strOption;
  if(typeof strHaisen === "undefined"){
    cart_haisen.innerHTML="なし";
  }else cart_haisen.innerHTML="位置指定 "+strHaisen+"cm";
  cart_panel.innerHTML=intPanel;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice11").value="見積もり金額："+(parseInt(url)+total);
return false;
}



function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice4=document.frm.choice5.value;
 var choice6=document.frm.choice6.value;
 var choice7=document.frm.choice7.value;
 var choice8=document.frm.choice8.value;
 var choice9=document.frm.choice9.value;
 var choice10=document.frm.choice10.value;
 var choice11=document.frm.choice11.value;
 var choice12=document.frm.choice12.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="" || choice6=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000a00000","999","999","999","wood","17600");



